export const MODAL_NAMES = {
  ABOUT_BATTERY: 'ABOUT_BATTERY',
  ADD_TO_CART: 'ADD_TO_CART',
  BLACK_FRIDAY_SPECIAL_JP: 'BLACK_FRIDAY_SPECIAL_JP',
  CONDITION: 'CONDITION',
  LAPTOP_PROCESSOR: 'LAPTOP_PROCESSOR',
  MACBOOK_PROCESSOR: 'MACBOOK_PROCESSOR',
  PAYPAY: 'PAYPAY',
  SELLER_INFO: 'SELLER_INFO',
  SIM_UNLOCKED: 'SIM_UNLOCKED',
  SIM: 'SIM',
  TRADE_IN: 'TRADE_IN',
  VERIFIED_REFURBISHED_JPP: 'VERIFIED_REFURBISHED_JPP',
} as const

export const ELEMENT_IDS = {
  STICKY_BARS_PORTAL_TARGET_DESKTOP: 'sticky-bar-portal-target-desktop',
  STICKY_BARS_PORTAL_TARGET_MOBILE: 'sticky-bar-portal-target-mobile',
  TAB_NAVIGATION: 'JapanProductPageTabNavigationInPage',
} as const

// Anchor ids targeted by the JP tab navigation. The `reviews` anchor is set by
// the global `ContainerReviews`; the rest are owned by JP containers.
export const SECTION_IDS = {
  OVERVIEW: 'overview',
  PRODUCT_FEATURE: 'product-feature',
  REVIEWS: 'reviews',
  WARRANTY: 'warranty',
  ABOUT: 'about',
} as const

export type ScrollBlock = 'start' | 'center' | 'end' | 'nearest'

export const TAB_SECTIONS: ReadonlyArray<{
  id: string
  translationKey:
    | 'overview'
    | 'productFeature'
    | 'reviews'
    | 'warranty'
    | 'about'
  scrollBlock?: ScrollBlock
  hasBadge?: boolean
}> = [
  { id: SECTION_IDS.OVERVIEW, translationKey: 'overview' },
  { id: SECTION_IDS.PRODUCT_FEATURE, translationKey: 'productFeature' },
  {
    id: SECTION_IDS.REVIEWS,
    translationKey: 'reviews',
    scrollBlock: 'start',
    hasBadge: true,
  },
  { id: SECTION_IDS.WARRANTY, translationKey: 'warranty' },
  { id: SECTION_IDS.ABOUT, translationKey: 'about' },
]

export const PRODUCT_GRADE = {
  PREMIUM: 9,
  EXCELLENT: 10,
  GOOD: 11,
  FAIR: 12,
} as const

export const RAKUTEN_URL =
  'https://www.backmarket.co.jp/ja-jp/service/rakuten-mobile'

export const BATTERY_OFFER_TYPE = {
  STANDARD: 0,
  NEW: 7,
  NINETY_NINE: 9,
} as const

export const DESKTOP_BREAKPOINT = 768 as const
